<template>
    <div class="no-results">
        <span v-html="text"></span>
        <TotemButton @click="onClick" color="primary" class="no-results__button" :label="buttonLabel" />
    </div>
</template>

<script>

    export default {
        props: {
            text: {
                type: String,
                required: true
            },
            buttonLabel: {
                type: String,
                required: true
            },
            onClick: {
                type: Function,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .no-results {
        display: flex;
        flex-direction: column;
        gap: 30px;
        background-color: $alabaster;
        border-radius: 5px;
        padding: 30px;
        justify-content: center;
        margin: 15px 0;

        &__button {
            width: max-content;
        }
    }
</style>
